import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-2016",
  "use": "icon-2016-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-2016\" viewBox=\"0 0 16 16\" id=\"icon-2016\">\n  <path d=\"m5.264 11.451 1.137 2.393 1.182-2.393-1.182-1.273zm2.862-2.256 1.385 2.916 1.441-2.916-1.441-1.551zm3.368 2.256 1.137 2.393 1.183-2.393-1.183-1.273z\" />\n  <path d=\"M14.57 3.689s-6.977-2.06-9.323-2.672a.695.695 0 0 0-.836.497L1.028 14.12a.708.708 0 0 0 .476.847.71.71 0 0 0 .876-.485l1.462-5.45 10.829-4.214a.607.607 0 0 0-.101-1.129z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol